// extracted by css-extract-rspack-plugin
export default {"clickable":"ExtendGridCell_clickable__Ry9fi"};